// Custom `renderSubLayers` for Viv's MultiscaleImageLayer that forces LINEAR
// texture interpolation at every pyramid level — including the highest-res
// (L0) tiles.
//
// Viv's built-in renderSubLayers hardcodes `interpolation: z === maxZoom ?
// "nearest" : "linear"`, so the deepest level (full-res L0) is sampled with
// NEAREST. When the user zooms past native that renders hard, blocky pixels
// ("really pixelated"). Everything else here is a verbatim copy of Viv's
// default so tile bounds / interleaved handling stay identical; only the
// interpolation choice changes.
import {XRLayer, BitmapLayer, getImageSize, isInterleaved} from "@hms-dbmi/viv";

export function linearRenderSubLayers(props: any) {
  const {
    bbox: {left, top, right, bottom},
    index: {x, y, z},
  } = props.tile;
  const {data, id, loader} = props;
  if ([left, bottom, right, top].some((v: number) => v < 0) || !data) {
    return null;
  }
  if (data.width === 0 || data.height === 0) {
    return null;
  }
  const base = loader[0];
  const {height, width} = getImageSize(base);
  const bounds = [
    left,
    data.height < base.tileSize ? height : bottom,
    data.width < base.tileSize ? width : right,
    top,
  ];
  if (isInterleaved(base.shape)) {
    const {photometricInterpretation = 2} = base.meta;
    return new BitmapLayer(props, {
      image: data,
      photometricInterpretation,
      bounds,
      id: `tile-sub-layer-${bounds}-${id}`,
      tileId: {x, y, z},
      extensions: [],
    });
  }
  return new XRLayer(props, {
    channelData: data,
    bounds,
    id: `tile-sub-layer-${bounds}-${id}`,
    tileId: {x, y, z},
    interpolation: "linear",
  });
}
